/* eslint arrow-parens: 0 */
/* eslint implicit-arrow-linebreak: 0 */

import { compose } from 'recompose';
import _map from 'lodash/map';
import _property from 'lodash/property';
import _values from 'lodash/values';
import _filter from 'lodash/filter';
import _curry from 'lodash/curry';
import _get from 'lodash/get';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import _omit from 'lodash/omit';
import _keyBy from 'lodash/keyBy';
import _includes from 'lodash/includes';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { DEFAULT_FILTER_GROUP } from '../../constants/filterSection.filterGroups';

// Factories
import getOperatorForFilterType from '../../factory/filterDialog.operator';

// Components
import FilterListItem from '../molecules/filterListItem';

// Helpers
import { getFilterId } from './filterDialog.filterType';
import { getUniqueFieldId } from './filterDialog.general';

// Reader
import filterGroupReader from '../../readers/FilterGroup';
var getFilterTypeFromValue = _property('type');
var getFilterTypeIdsList = function getFilterTypeIdsList(filterValues) {
  return _map(filterValues, getFilterTypeFromValue);
};
var getSelectedFilterTypes = compose(getFilterTypeIdsList, _values);
var isSelected = _curry(function (selectedFilterSet, filterType) {
  var filterTypeId = getFilterId(filterType);
  return !selectedFilterSet.has(filterTypeId);
});
var getUnselectedFilterTypes = function getUnselectedFilterTypes(filterTypes) {
  var selectedFilterTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  var selectedFilterSet = new Set(selectedFilterTypes);
  var remainingFilterTypes = _filter(filterTypes, isSelected(selectedFilterSet));
  return remainingFilterTypes;
};
var getFilterTypesForField = function getFilterTypesForField(valuesMap, filterTypes, fieldId) {
  var remainingValuesMap = _omit(valuesMap, [fieldId]);
  var selectedFilterTypes = getSelectedFilterTypes(remainingValuesMap);
  var unselectedFilterTypes = getUnselectedFilterTypes(filterTypes, selectedFilterTypes);
  return unselectedFilterTypes;
};

/**
 * @name getDefaultSelectedFilterType
 * @description To find the leftover filter type to find it's operator.
 * @param {object} valuesMap
 * @param {string} id
 * @param {array} filterTypes
 */
var getDefaultSelectedFilterType = function getDefaultSelectedFilterType(valuesMap, id, filterTypes) {
  var valueMapTypess = _keyBy(valuesMap, 'type');
  var leftOverFilter = _filter(filterTypes, function (filter) {
    return !valueMapTypess[_get(filter, 'id')];
  });
  if (!_isEmpty(leftOverFilter)) {
    return _get(_head(leftOverFilter), 'id'); // return left over filter type.
  }

  return _get(valuesMap, "".concat(id, ".type")); // return default (first) filter type.
};

var getOperatorsForField = function getOperatorsForField(valuesMap, id, filterTypes) {
  var defaultFilterType = getDefaultSelectedFilterType(valuesMap, id, filterTypes);
  var selectedFilterTypeId = _get(valuesMap, "".concat(id, ".type"), defaultFilterType);
  var filterType = _find(filterTypes, {
    id: selectedFilterTypeId
  });
  return getOperatorForFilterType(filterType);
};

/**
 * returns field config that is compatible with `FormBuilder`
 * @param {string[]} defaultFilterTypes
 * @param {any[]} filterTypes
 * @param {Object.<string, any>} valuesMap
 * @param {string} id
 * @param {string} [selectedFilterGroup]
 * @param {boolean} [isDisabled]
 * @returns
 */
var makeFilterRowField = function makeFilterRowField(defaultFilterTypes, filterTypes, valuesMap, id, selectedFilterGroup, isDisabled) {
  var fieldId = id || getUniqueFieldId();
  var fieldFilterTypes = getFilterTypesForField(valuesMap, filterTypes, fieldId);
  var operators = getOperatorsForField(valuesMap, fieldId, filterTypes);
  var selectedFilterGroupId = filterGroupReader.id(selectedFilterGroup);
  var currentFilterType = _get(valuesMap, "".concat(fieldId, ".type"));
  var isDefaultFilterRow = selectedFilterGroupId === DEFAULT_FILTER_GROUP && _includes(defaultFilterTypes, currentFilterType);
  var keyByFilterTypes = _keyBy(filterTypes, 'id');
  var filterTypeDetails = keyByFilterTypes[currentFilterType] || EMPTY_OBJECT;
  var hideFilter = filterTypeDetails.hideInFilterDialog;
  var nonRemovable = filterTypeDetails.nonRemovable;
  return {
    id: fieldId,
    renderer: FilterListItem,
    renderOptions: {
      filterTypes: fieldFilterTypes,
      operators: operators,
      isDefaultFilterRow: isDefaultFilterRow,
      hideFilter: hideFilter,
      isDisabled: isDisabled,
      nonRemovable: nonRemovable
    }
  };
};
export default makeFilterRowField;